S.scrollTop = {

    elements: {
        $backToTop: null,
    },

    init()
    {
        this.elements.$backToTop.on('click', (e) =>
        {
            e.preventDefault();

            $('html, body').animate(
                {
                    scrollTop: 0,
                }, 200);
        });
    },
};
